<template lang="pug">
  .info(@mouseover="active = !active" @mouseout="active = !active")
    span.info(v-if="active")
      slot
    span.info(v-else) (?)
</template>

<script>
export default {
  name: 'info-span',
  data() {
    return {
      active: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/definitions';

.info {
  display: inline;
  color: $color-desc;
  font-weight: normal;
  font-size: 13px;
  text-transform: none;
  vertical-align: top;
  cursor: pointer;
}
</style>
